export function normalizeTableSort(value,fallback,allowed) {
  return value && typeof value.key==='string' && allowed.includes(value.key) && ['asc','desc'].includes(value.dir)
    ? {key:value.key,dir:value.dir} : {...fallback};
}
export function readTableSort(storage,key,fallback,allowed) {
  if(!key)return {...fallback};
  try{return normalizeTableSort(JSON.parse(storage?.getItem(key)||'null'),fallback,allowed);}catch{return {...fallback};}
}
export function writeTableSort(storage,key,value,fallback,allowed) {
  if(!key)return;
  try{storage?.setItem(key,JSON.stringify(normalizeTableSort(value,fallback,allowed)));}catch{/* Sorting still works when storage is unavailable. */}
}

export function browserSortStorage(){try{return globalThis.localStorage;}catch{return undefined;}}
export function tableSortKey(user,table,prefix='rconf:table-sort:v1:'){
 if(!user?.id || !/^[a-z][a-z0-9-]*$/.test(table))return '';
 return prefix+JSON.stringify([String(user.id),String(user.company_id||''),table]);
}
export const workspaceSorts={
 'my-recordings':{fallback:{key:'default',dir:'desc'},allowed:['default','name','date','duration']},
 meetings:{fallback:{key:'default',dir:'desc'},allowed:['default','name','date']},
 team:{fallback:{key:'date',dir:'desc'},allowed:['name','organizer','type','date','duration']},
 external:{fallback:{key:'UF_DATE_CREATE',dir:'desc'},allowed:['UF_NAME','UF_DATE_CREATE']},
};
export function readWorkspaceSort(user,table,storage=browserSortStorage()){
 const config=workspaceSorts[table];
 return readTableSort(storage,tableSortKey(user,table),config.fallback,config.allowed);
}
export function workspaceSortQuery(table,value){
 const config=workspaceSorts[table];const sort=normalizeTableSort(value,config.fallback,config.allowed);
 if(sort.key==='default')return {};
 return {sort:sort.key,order:sort.dir.toUpperCase()};
}
export function teamRecordingsEndpoint(sort){
 const value=normalizeTableSort(sort,workspaceSorts.team.fallback,workspaceSorts.team.allowed);
 const params=new URLSearchParams({view:'list'});
 if(value.key!=='date'||value.dir!=='desc'){params.set('sort',value.key);params.set('order',value.dir.toUpperCase());}
 return '/api/team-recordings?'+params;
}
export function externalRecordingsEndpoint(sort,page=1,query=''){
 const value=workspaceSortQuery('external',sort);
 const params=new URLSearchParams({page:String(page),...value,view:'list'});
 if(query.trim())params.set('query',query.trim());
 return '/api/external-recordings?'+params;
}
